//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BottomNav from "../components/BottomNav";
import util from '@/lib/util';
import {formatDate} from '../../../src/lib/date';

export default {
    name: "shop",
    components: {
        BottomNav,
    },
    filters: {
        // formatDate(time, type) {
        //     var date = new Date(time);
        //     if (type == 1) {
        //         return formatDate(date, 'yyyy/MM/dd');
        //     }
        //     return formatDate(date, 'yyyy-MM-dd hh:mm');
        // }
    },
    data() {
        return {
            list: [],
            refreshing: false,
            pageIndex: 0,
            pageSize: 10,
            loading: false,
            finished: false,
            downloadUrl: util.ApiUrl + '/file/download/',
        };
    },

    methods: {
        onRefresh() {
            this.pageIndex = 1;
            this.getGoods();
        },
        onLoad() {
            this.pageIndex++;
            this.getGoods()
        },
        getGoods() {
            this.refreshing = this.pageIndex === 1;
            this.loading = this.pageIndex > 1;
            var page = {
                status: 0,
                maxResultCount: this.pageSize,
                skipCount: (this.pageIndex - 1) * this.pageSize
            };
            abp.ajax.post('/api/services/app/Good/SearchGoods', page).then((res) => {
                if (this.pageIndex === 1) {
                    this.list = [];
                }
                this.list.push(...res.data.result.items);
                // console.log(this.list);
                if (res.data.result.items.length < this.pageSize) {
                    this.finished = true;
                } else {
                    this.finished = false;
                }
            }).then(() => {
                this.refreshing = false;
                this.loading = false;
            }).catch((error) => {
                this.refreshing = false;
                this.loading = true;
            }).finally(() => {
                // this.refreshing = false;
                // this.loading = true;
            });
        },
        productDetail(id) {
            this.$router.push({path: '/productDetail/' + id})
        }
    },
    created() {
        // this.loading = true;
        this.onRefresh();
    }
};
